import React from 'react';
import CloseButton from '../button/CloseButton';

interface MessageProps {
    title: string;
    children: React.ReactNode;
    onClose: () => void;
}

const Message = (props: MessageProps) => {
  return (
    <div className='alert alert-primary u-mb-2' role='status'>
      {/* Flex row rather than Bootstrap's `alert-dismissible` (which absolutely positions
          its own `.btn-close`), because the shared CloseButton positions itself with
          `margin-left: auto`. */}
      <div className='d-flex align-items-start'>
        <div className='flex-grow-1'>
          <p className='u-text-bold u-mb-1'>{props.title}</p>
          {props.children}
        </div>
        <CloseButton onClick={props.onClose} />
      </div>
    </div>
  )
};

export default Message
